<template>
    <div class="container">
    <div class="row">
        <div v-for="(pre, index) in presentacion" :key="index" class="justify-content-center" style="margin-top: 20px; text-align: justify;">
            <div v-html="pre.Presentacion"></div>
        </div>
		<div v-if="user === ''">
                    <b-modal v-model="modalShow" id="modalPopover" title="Donaciones" ok-only>
                        <b-card
                            border-variant="primary"
                            header="Ayúdanos para mantener y mejorar DIFRACO"
                            header-bg-variant="primary"
                            header-text-variant="white"
                            align="center"
                        >
                            <b-card-text ><b>Donaciones Internacionales</b></b-card-text>
                            <b-card-text>Paypal: difraco.admon@gmail.com</b-card-text>
                            <b-card-text><b>Donaciones en Colombia</b></b-card-text>
                            <b-card-text>Cuenta de Ahorros Bancolombia: 43650110464</b-card-text>
                            <b-card-text>Si tiene alguna inquietud no dude en contactarnos a: difraco.admon@gmail.com</b-card-text>
                        </b-card>
                    </b-modal>
                </div>
                <b-card header="Copyright © | DIFRACO" class="text-center">
                    <b-card-text>Reconocimiento - NoComercial - CompartirIgual (by-nc-sa): No se permite un uso comercial
                        de la obra original ni de las posibles obras derivadas, la distribución de las cuales se debe hacer
                        con una licencia igual a la que regula la obra original.
                    </b-card-text>
                    <img style="width:20%;" class="card-img-bottom" :src="ImgPath" />
                </b-card>
                <br>
    </div>
</div>
</template>

<script>

import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import axios from 'axios';

export default{

    data(){

    return{
        presentacion:'',
	modalShow: true,
        user: '',
        ImgPath: "http://difraco.com.co:8000/Media/copyright_DIFRACO.jpg",
    }
    },

    methods:{
        refreshData(){
            axios.get("http://difraco.com.co:8000/presentacion")
            .then((response)=>{
                this.presentacion=response.data;
            })
        },

    },

    mounted:function(){
        this.refreshData();
    }

    };

</script>
